import { AllNbisivPermission } from "presentation/constant/ANAInfo/NbisivPermission";
import { useGeneralCsvReportVM } from "presentation/hook/GeneralCsvReport/useGeneralCsvReportVM";
import { useANAInfoTracked } from "presentation/store/ANAInfo";
import { memo, useEffect, useState } from "react";
import { Loader } from "veronica-ui-component/dist/component/core";
import GeneralCsvReportPanel from "./GeneralCsvReportPanel";


const GeneralCsvReportMaintenance: React.FC = () => {
    const [isLoading, setIsLoading] = useState(true);
    const generalCsvReportVM = useGeneralCsvReportVM();

    const [anaInfoState] = useANAInfoTracked();
    const { allNbisivPermission } = anaInfoState;
    useEffect(() => {
        const initialScreen = async () => {
            try {
                const results = await Promise.allSettled([
                    generalCsvReportVM.loadDropdownOption(),
                ]);
                results?.forEach((result, index) => {
                    if (index === 0 && result.status === 'fulfilled') {

                    }
                })
            } catch (error) {
                setIsLoading(false);
            }
        }
        initialScreen().then((data) => {
            generalCsvReportVM.initGeneralCsvReportList(allNbisivPermission as AllNbisivPermission).then((data) => {
                setIsLoading(false)
            }).catch(error => {
                setIsLoading(false)
            });
        }).catch(error => {
            setIsLoading(false)
        });

    }, [generalCsvReportVM, allNbisivPermission])

    if (isLoading) return <Loader Indicator="Stripe" size="Large" />;

    return <>
        <div className={`main-comp-wrapper im-hide-side-form-draggable`}>
            {<>
                <GeneralCsvReportPanel /></>}
        </div>
    </>
}

export default memo(GeneralCsvReportMaintenance);